import React, { useEffect, useState } from "react";
import axios from "axios";
import { Icon } from "@iconify/react";
import { useDispatch, useSelector } from "react-redux";
import { setAllPromo } from "../store/slices/user";
import { useConfig } from "../contexts/ConfigContext";
import PromotionCard from "../components/PromotionCard";
import PromotionDetail from "../components/PromotionDetail";

// Declare the shared promise at module scope
let promotionsFetchPromise = null;

// Promotion component
const Promotion = () => {
  const dispatch = useDispatch();
  const { apiBaseUrl } = useConfig();
  const allPromo = useSelector((state) => state.user.allPromo);
  const [selectedPromotion, setSelectedPromotion] = useState(null);

  // Fetch promotions from the server
  useEffect(() => {
    let cancelled = false;

    if (!promotionsFetchPromise) {
      promotionsFetchPromise = axios
        .get("https://api.pgzone88.com/promotion/getavailable")
        .finally(() => {
          promotionsFetchPromise = null;
        });
    }

    promotionsFetchPromise
      .then((res) => {
        if (cancelled) return;
        const list = res?.data?.data || res?.data || [];
        dispatch(setAllPromo(list));
      })
      .catch(() => {
        if (cancelled) return;
        dispatch(setAllPromo([]));
      });

    return () => {
      cancelled = true;
    };
  }, [dispatch]);

  console.log(allPromo);
  // Resolve image URL
  const resolveImg = (url) => {
    if (!url) return "";
    return url.startsWith("http") ? url : `${apiBaseUrl}${url}`;
  };

  // Helpers for display
  // Inline SVG placeholder to avoid network calls and infinite onError loops
  const makeSvgPlaceholder = (w, h, text = "Promotion Image") => {
    const svg = `<svg xmlns='http://www.w3.org/2000/svg' width='${w}' height='${h}'><rect width='100%' height='100%' fill='#2d2d2d'/><text x='50%' y='50%' dominant-baseline='middle' text-anchor='middle' fill='#f59e0b' font-family='sans-serif' font-size='16'>${text}</text></svg>`;
    return `data:image/svg+xml;charset=UTF-8,${encodeURIComponent(svg)}`;
  };
  const getImg = (promo, w = 800, h = 300) => {
    const url = promo?.imageUrl;
    return url ? resolveImg(url) : makeSvgPlaceholder(w, h);
  };
  const bonusText = (p) => {
    if (!p) return "";
    const amt = p.BonusAmount;
    if (p.BonusAmountType && p.BonusAmountType.includes("%")) {
      const max = p.BonusMaximum != null ? ` สูงสุด ${p.BonusMaximum}` : "";
      return `โบนัส ${amt}%${max}`;
    }
    if (typeof amt === "number") {
      const max = p.BonusMaximum != null ? ` (สูงสุด ${p.BonusMaximum})` : "";
      return `รับเพิ่ม ${amt}${max}`;
    }
    return "";
  };
  const depositText = (p) => {
    if (!p) return "";
    if (p.BonusDepMinimum === p.BonusDepMaximum)
      return `ฝาก ${p.BonusDepMinimum}`;
    if (p.BonusDepMinimum != null && p.BonusDepMaximum != null)
      return `ฝาก ${p.BonusDepMinimum}-${p.BonusDepMaximum}`;
    if (p.BonusDepMinimum != null) return `ฝากขั้นต่ำ ${p.BonusDepMinimum}`;
    return "";
  };
  const turnoverText = (p) => {
    if (!p || !p.WithdrawConditionDetail1) return "";
    return `ทำเทิร์น ${p.WithdrawConditionDetail1} เท่า`;
  };
  const receiveText = (p) => {
    if (!p || !p.PromotionReceive) return "";
    return `จำนวนในการรับ ${p.PromotionReceive}`;
  };

  const handleReadMore = (promotion) => {
    setSelectedPromotion(promotion);
  };

  const handleBackToList = () => {
    setSelectedPromotion(null);
  };

  // If a promotion is selected, show detailed view
  if (selectedPromotion) {
    return (
      <PromotionDetail
        promotion={selectedPromotion}
        onBack={handleBackToList}
        getImg={getImg}
        makeSvgPlaceholder={makeSvgPlaceholder}
        depositText={depositText}
        bonusText={bonusText}
        turnoverText={turnoverText}
        receiveText={receiveText}
      />
    );
  }

  // Default list view
  return (
    <div
      style={{
        padding: 16,
        color: "#fff",

        margin: 24,
        borderRadius: 8,
      }}
    >
      <div style={{ marginTop: 10 }}>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            marginBottom: 10,
          }}
        >
          <h1
            style={{
              color: "var(--primaryColor)",
              margin: 0,
              fontSize: 32,
              display: "flex",
              alignItems: "center",
              gap: 12,
            }}
          >
            <Icon
              icon="fluent-mdl2:giftbox-open"
              width="40"
              height="40"
              style={{ color: "var(--primaryColor)" }}
            />
            โปรโมชั่นแนะนำ
          </h1>
        </div>
      </div>
      <hr style={{ border: "1px solid #404040", marginBottom: 20 }} />
      {/* Promotion blogs post list */}
      <div
        className="promotion-grid"
        style={{
          display: "grid",
          gap: 24,
          gridTemplateColumns: "repeat(3, 1fr)",
        }}
      >
        {allPromo?.map((p) => (
          <PromotionCard
            key={p.PromotionID}
            promotion={p}
            onClick={handleReadMore}
            getImg={getImg}
            makeSvgPlaceholder={makeSvgPlaceholder}
            bonusText={bonusText}
            depositText={depositText}
          />
        ))}
        {(!allPromo || allPromo.length === 0) && (
          <div style={{ opacity: 0.8 }}>ไม่มีโปรโมชั่นในขณะนี้</div>
        )}
      </div>
      <style>
        {`
          @media (max-width: 768px) {
            h1 {
              font-size: 24px !important;
            }
            
            .promotion-grid {
              grid-template-columns: 1fr !important;
              gap: 16px !important;
            }
            
            .restricted-section,
            .playable-section {
              margin: 16px 0 !important;
            }
            
            .restricted-section .header,
            .playable-section .header {
              padding: 12px 16px !important;
              flex-direction: column !important;
              text-align: center !important;
              gap: 8px !important;
            }
            
            .restricted-section .icon-container,
            .playable-section .icon-container {
              width: 32px !important;
              height: 32px !important;
              padding: 6px !important;
            }
            
            .restricted-section .content,
            .playable-section .content {
              text-align: center !important;
            }
            
            .restricted-section .content h2,
            .playable-section .content h2 {
              font-size: 16px !important;
            }
            
            .restricted-section .content p,
            .playable-section .content p {
              font-size: 12px !important;
            }
          }
          
          @media (min-width: 769px) and (max-width: 1024px) {
            .promotion-grid {
              grid-template-columns: repeat(2, 1fr) !important;
              gap: 20px !important;
            }
          }
          
          @media (min-width: 1025px) {
            .promotion-grid {
              grid-template-columns: repeat(3, 1fr) !important;
            }
          }
        `}
      </style>
    </div>
  );
};

export default Promotion;
